import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Base Icon component that provides consistent styling and behavior
 * for all SVG icons in the application.
 */
export const Icon = ({ size = 16, color = "currentColor", className = "", viewBox = "0 0 16 16", children, ...props }) => {
    return (_jsx("svg", { width: size, height: size, viewBox: viewBox, fill: "none", xmlns: "http://www.w3.org/2000/svg", className: className, "aria-hidden": "true", role: "img", ...props, children: children }));
};
